import { BlocklyError } from '../../utils/blockly-error';
import { FixedBlockType } from '../../types/block-type';
import { setupExpression, xpathElementConverter, xpathTextContentConverter2Number, xpathTextContentConverter2String, } from 'console/blockly/utils/xpath-converter';
import { getWeekdays } from 'console/blockly/utils/time';
export function resolverX2B(child) {
    if (child == null) {
        return null;
    }
    const childType = child
        .getAttribute('type')
        ?.replace(/:+[0-9]*/g, '');
    if (!childType) {
        throw new BlocklyError('resolverX2B-1', 'не смог найти тип блока');
    }
    const converter = allX2B[childType];
    if (!converter) {
        throw new BlocklyError('resolverX2B-2', `Конвертер для блока ${childType} неопределён`);
    }
    try {
        return converter(child);
    }
    catch (e) {
        throw new BlocklyError('resolverX2B-3', e);
    }
}
export function statementX2B(el) {
    if (el == null) {
        return null;
    }
    const child = el.children.item(0);
    if (!child) {
        throw new BlocklyError('statementX2B', 'Исполнительный блок пуст');
    }
    return resolverX2B(child);
}
export function nextX2B(block) {
    const validExpression = setupExpression('./blockly:next/blockly:block');
    const evaluator = new XPathEvaluator();
    try {
        const newNext = evaluator
            .evaluate(validExpression, block, (ns) => ns === 'blockly'
            ? 'https://developers.google.com/blockly/xml'
            : null, XPathResult.ANY_TYPE, null)
            .iterateNext();
        if (!newNext) {
            return null;
        }
        return resolverX2B(newNext);
    }
    catch (e) {
        throw new BlocklyError('nextParser', 'Не смог распарсить next');
    }
}
function andOrX2B(el, type) {
    return {
        type: type,
        clauses: [1, 2].map((index) => {
            const clauseBlock = el.querySelector(`block[id="${el.getAttribute('id')}"] > [name="${type}_${index}"] > block[type]`);
            if (clauseBlock == null) {
                return null;
            }
            return resolverX2B(clauseBlock);
        }),
    };
}
function doHeatModeForHeatCircuitX2B(el) {
    const heat_mode_id = parseInt(el.getAttribute('type')?.toString().split(':')[1] ?? '0', 10);
    const circuit_id_or_1 = xpathTextContentConverter2Number(el, 'zones');
    const circuitOrAll = circuit_id_or_1 == 1
        ? { for: 'all' }
        : { for: 'single', circuit: circuit_id_or_1 };
    return {
        type: FixedBlockType.do_heat_mode_for_heat_circuit,
        mode: heat_mode_id,
        name: xpathTextContentConverter2String(el, 'name'),
        next: nextX2B(el),
        ...circuitOrAll,
    };
}
function ifThenElseX2B(el, type) {
    return {
        type: type,
        comparator: resolverX2B(xpathElementConverter(el, 'value/blockly:block')),
        then: statementX2B(xpathElementConverter(el, 'statement[@name="then"]')),
        else: type === FixedBlockType.if_then_else
            ? statementX2B(xpathElementConverter(el, 'statement[@name="else"]'))
            : null,
        next: nextX2B(el),
    };
}
function sensorStateX2B(el, type) {
    return {
        type: type,
        id: xpathTextContentConverter2Number(el, 'id'),
        argument: xpathTextContentConverter2Number(el, 'argument'),
    };
}
export const allX2B = {
    //run
    [FixedBlockType.linear]: (el) => ({
        type: FixedBlockType.linear,
        scenario_name: xpathTextContentConverter2String(el, 'scenario_name'),
        statement: statementX2B(xpathElementConverter(el, 'statement')),
    }),
    [FixedBlockType.if_run]: (el) => ({
        type: FixedBlockType.if_run,
        scenario_name: xpathTextContentConverter2String(el, 'scenario_name'),
        comparator: resolverX2B(xpathElementConverter(el, 'value/blockly:block')),
        then: statementX2B(xpathElementConverter(el, 'statement')),
    }),
    [FixedBlockType.loop]: (el) => ({
        type: FixedBlockType.loop,
        scenario_name: xpathTextContentConverter2String(el, 'scenario_name'),
        value: xpathTextContentConverter2Number(el, 'value'),
        unit_time: xpathTextContentConverter2Number(el, 'unit_time'),
        statement: statementX2B(xpathElementConverter(el, 'statement')),
    }),
    [FixedBlockType.schedule_run]: (el) => ({
        type: FixedBlockType.schedule_run,
        scenario_name: xpathTextContentConverter2String(el, 'scenario_name'),
        weekday_register: getWeekdays(el),
        hour: xpathTextContentConverter2Number(el, 'hour'),
        min: xpathTextContentConverter2Number(el, 'min'),
        statement: statementX2B(xpathElementConverter(el, 'statement')),
    }),
    //logic
    [FixedBlockType.and]: (block) => andOrX2B(block, FixedBlockType.and),
    [FixedBlockType.or]: (block) => andOrX2B(block, FixedBlockType.or),
    [FixedBlockType.not]: (el) => ({
        type: FixedBlockType.not,
        inp: resolverX2B(xpathElementConverter(el, 'value[@name="inp"]/blockly:block')),
    }),
    [FixedBlockType.if_then]: (block) => ifThenElseX2B(block, FixedBlockType.if_then),
    [FixedBlockType.if_then_else]: (block) => ifThenElseX2B(block, FixedBlockType.if_then_else),
    [FixedBlockType.numeric_comparator]: (el) => ({
        type: FixedBlockType.numeric_comparator,
        comparator_type: xpathTextContentConverter2Number(el, 'comparator_type'),
        left: resolverX2B(xpathElementConverter(el, 'value/blockly:block')),
        right: xpathTextContentConverter2Number(el, 'right'),
    }),
    [FixedBlockType.sensor_comparator]: (el) => ({
        type: FixedBlockType.sensor_comparator,
        comparator_type: xpathTextContentConverter2Number(el, 'comparator_type'),
        left: resolverX2B(xpathElementConverter(el, 'value[@name="left"]/blockly:block')),
        right: resolverX2B(xpathElementConverter(el, 'value[@name="right"]/blockly:block')),
    }),
    //do
    [FixedBlockType.do_heat_mode_for_heat_circuit]: doHeatModeForHeatCircuitX2B,
    [FixedBlockType.do_notification]: (el) => ({
        type: FixedBlockType.do_notification,
        id: xpathTextContentConverter2Number(el, 'id'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_output_action]: (el) => ({
        type: FixedBlockType.do_output_action,
        id: xpathTextContentConverter2Number(el, 'id'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_pump]: (el) => ({
        type: FixedBlockType.do_pump,
        argument: xpathTextContentConverter2Number(el, 'argument'),
        id: xpathTextContentConverter2Number(el, 'id'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_relay]: (el) => ({
        type: FixedBlockType.do_relay,
        argument: xpathTextContentConverter2Number(el, 'argument'),
        id: xpathTextContentConverter2Number(el, 'id'),
        next: nextX2B(el),
    }),
    [FixedBlockType.set_guard]: (el) => ({
        type: FixedBlockType.set_guard,
        id: xpathTextContentConverter2Number(el, 'id'),
        argument: xpathTextContentConverter2Number(el, 'argument'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_buzzer]: (el) => ({
        type: FixedBlockType.do_buzzer,
        argument: xpathTextContentConverter2Number(el, 'argument'),
        id: xpathTextContentConverter2Number(el, 'id'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_tap]: (el) => ({
        type: FixedBlockType.do_tap,
        argument: xpathTextContentConverter2Number(el, 'argument'),
        id: xpathTextContentConverter2Number(el, 'id'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_temperature_in_circuit]: (el) => ({
        type: FixedBlockType.do_temperature_in_circuit,
        target_temp: xpathTextContentConverter2Number(el, 'target_temp'),
        circuit: xpathTextContentConverter2Number(el, 'circuit'),
        next: nextX2B(el),
    }),
    [FixedBlockType.pause]: (el) => ({
        type: FixedBlockType.pause,
        value: xpathTextContentConverter2Number(el, 'value'),
        unit_time: xpathTextContentConverter2Number(el, 'unit_time'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_scenario]: (el) => ({
        type: FixedBlockType.do_scenario,
        scenario: xpathTextContentConverter2Number(el, 'scenario'),
        next: nextX2B(el),
    }),
    [FixedBlockType.do_return]: (el) => ({
        type: FixedBlockType.do_return,
        next: nextX2B(el),
    }),
    [FixedBlockType.do_break]: (el) => ({
        type: FixedBlockType.do_break,
        next: nextX2B(el),
    }),
    [FixedBlockType.do_continue]: (el) => ({
        type: FixedBlockType.do_continue,
        next: nextX2B(el),
    }),
    //sensor
    [FixedBlockType.analog_input]: (el) => ({
        type: FixedBlockType.analog_input,
        id: xpathTextContentConverter2Number(el, 'id'),
    }),
    [FixedBlockType.radio_input]: (el) => ({
        type: FixedBlockType.radio_input,
        id: xpathTextContentConverter2Number(el, 'id'),
        value_type: xpathTextContentConverter2Number(el, 'value_type'),
    }),
    [FixedBlockType.temperature_input]: (el) => ({
        type: FixedBlockType.temperature_input,
        id: xpathTextContentConverter2Number(el, 'id'),
    }),
    //sensor-states
    [FixedBlockType.analog_input_state]: (block) => sensorStateX2B(block, FixedBlockType.analog_input_state),
    [FixedBlockType.analog_temperature_sensor_state]: (block) => sensorStateX2B(block, FixedBlockType.analog_temperature_sensor_state),
    [FixedBlockType.state_heat_mode_for_heat_circuit]: (el) => ({
        type: FixedBlockType.state_heat_mode_for_heat_circuit,
        id: xpathTextContentConverter2Number(el, 'id'),
        argument: xpathTextContentConverter2Number(el, 'argument'),
    }),
    [FixedBlockType.guard_state]: (block) => sensorStateX2B(block, FixedBlockType.guard_state),
    [FixedBlockType.pump_state]: (block) => sensorStateX2B(block, FixedBlockType.pump_state),
    [FixedBlockType.radio_sensor_state]: (block) => sensorStateX2B(block, FixedBlockType.radio_sensor_state),
    [FixedBlockType.humidity_radio_sensor_state]: (block) => sensorStateX2B(block, FixedBlockType.humidity_radio_sensor_state),
    [FixedBlockType.radio_sensor_433_state]: (block) => sensorStateX2B(block, FixedBlockType.radio_sensor_433_state),
    [FixedBlockType.relay_state]: (block) => sensorStateX2B(block, FixedBlockType.relay_state),
    [FixedBlockType.buzzer_state]: (block) => sensorStateX2B(block, FixedBlockType.buzzer_state),
    [FixedBlockType.tap_state]: (block) => sensorStateX2B(block, FixedBlockType.tap_state),
    [FixedBlockType.wired_temperature_sensor_state]: (block) => sensorStateX2B(block, FixedBlockType.wired_temperature_sensor_state),
    [FixedBlockType.boiler_adapter]: (block) => sensorStateX2B(block, FixedBlockType.boiler_adapter),
    //time
    [FixedBlockType.weekdays_input]: (el) => ({
        type: FixedBlockType.weekdays_input,
        weekday_register: getWeekdays(el),
    }),
    [FixedBlockType.time_comparator]: (el) => ({
        type: FixedBlockType.time_comparator,
        comparator_type: xpathTextContentConverter2Number(el, 'comparator_type'),
        hour: xpathTextContentConverter2Number(el, 'hour'),
        min: xpathTextContentConverter2Number(el, 'min'),
    }),
};
